export default __webpack_public_path__ + "static/IBMPlexSans-SemiBoldItalic-Cyrillic-6557a3c33c4218db60662d4e8995b703.woff2";